function img_to_bg($o) {
    if (typeof $o === "undefined") $o = $(".img-to-bg");
    $o.each(function () {
        if ($(this).find("> img").length && $(this).find("> img").attr("src")) {
            $(this).css("background-image", "url('" + $(this).find("> img").attr("src") + "')");
            $(this).addClass("img-to-bg--inited");
        }
    });
}

/*

Slider

 */



/*

Gallery and Modal Popups

 */

function fancybox_init() {

    if (!$("body").hasClass("fancybox-inited")) {

        if ($().fancybox) {
            $.fancybox.options_modal = {
                slideShow: false,
                hash: false,
                clickContent: false,
                clickSlide: false,
                clickOutside: false,
                keyboard: false,
                mobile: {
                    clickSlide: false
                },
                ajax: {
                    settings: {
                        cache: false
                    }
                },
                baseClass: "fancybox-container--popup",
                trapFocus: false,
                autoFocus: false,
                touch: false,
                popup_default: true,
                btnTpl : {
                    smallBtn: '<button data-fancybox-close class="fancybox-close-small"><i class="icon-cross-slim"></i></button>'
                },
                afterLoad: function (instance, current) {
                    console.log("afterLoad", current, current.$content);
                    current.$content.wrap("<div>");
                },
            };
            if ($().tooltipster) {
                $.fancybox.defaults.beforeLoad = function (instance, current) {
                    var tooltips = $.tooltipster.instances();
                    $.each(tooltips, function (i, tooltip) {
                        tooltip.close();
                    });
                };
            }
            $.fancybox.defaults.hash = false;
            $.fancybox.defaults.errorTpl = '<div><div class="panel panel--compact"><div class="panel__content"><p>Произошла ошибка при загрузке. <br /> Попробуйте ещё раз.</p></div></div></div>';
        }

        $('body').on('mousewheel', function (e) {
            if ($(".fancybox-is-zoomable").length) {
                e.preventDefault();
                var instance = $.fancybox.getInstance();
                if ($(".fancybox-is-zoomable").length && instance.canPan() && e.deltaY > 0) {
                    instance.scaleToFit();
                } else if ($(".fancybox-can-zoomIn").length && instance.isScaledDown() && e.deltaY < 0) {
                    instance.scaleToActual(e.clientX, e.clientY);
                }
            }
        });

        $("body").addClass("fancybox-inited");
    }

    if (jQuery().fancybox) {

        var options = {
            slideShow: false,
            hash: true,
            loop: true,
            idleTime: 10,
            margin: [44, 0],
            gutter: 50,
            keyboard: true,
            animationEffect: "zoom",
            arrows: true,
            infobar: true,
            toolbar: true,
            buttons: [
                'slideShow',
                'fullScreen',
                'thumbs',
                'close'
            ],
            thumbs: {
                autoStart: false,
                hideOnClose: true
            },
        };

        $fancybox_links_all = $("[data-fancybox]").not(".fancybox-inited");

        $fancybox_links = $fancybox_links_all.not("[data-type='ajax']");
        fancybox_links_by_group = [];
        groups = [];
        $fancybox_links.each(function () {
            var group = $(this).attr("data-fancybox");
            if (!group) group = "";
            if ($.inArray(group, groups) < 0) groups.push(group);
        });
        for (group in groups) {
            options_current = $.extend(true, {}, options);
            var $items = $fancybox_links.filter("[data-fancybox='" + groups[group] + "']");
            var $first = $items.eq(0);
            if (typeof $first.attr("data-fancybox-loop") !== "undefined") {
                options_current["loop"] = $first.data("fancybox-loop");
            }
            $items.fancybox(options_current).addClass("fancybox-inited");
        }

        $fancybox_links_ajax = $fancybox_links_all.filter("[data-type='ajax']");
        $fancybox_links_ajax.each(function () {
            if ($(this).attr("data-type") == "ajax" || $(this).attr("data-src")) {
                options = $.fancybox.options_modal;
            }
            $(this).fancybox(options);
        }).addClass("fancybox-inited");
    }
}




/*

 Input Masks

 */

function mask_init() {

    if (!$("body").hasClass("inputmask-inited")) {
        Inputmask.extendDefaults({
            showMaskOnHover: false,
            showMaskOnFocus: true,
            onKeyDown: function(event, buffer, caretPos, opts) {
                if (event && event.target && !$(event.target).inputmask('isComplete')) {
                    $(event.target).removeClass("mask-complete");
                    $(event.target).removeClass("mask-incomplete");
                }
            },
            oncomplete: function(event) {
                if (event && event.target) {
                    $(event.target).addClass("mask-complete");
                    $(event.target).removeClass("mask-incomplete");
                }
            },
            onincomplete: function(event) {
                if (event && event.target) {
                    $(event.target).removeClass("mask-complete");
                    $(event.target).addClass("mask-incomplete");
                    $(event.target).val("");
                }
            },
        });

        $("body").addClass("inputmask-inited")
    }

    $(".mask-phone-ru").filter(":not(.mask-inited)").inputmask({
        definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
        },
        mask: "+7 (###) ###-##-##",
        placeholder: "_"
    }).addClass("mask-inited");

    $(".passport").filter(":not(.mask-inited)").inputmask({
        definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
        },
        mask: "##########",
        placeholder: "_"
    }).addClass("mask-inited");

    $(".passport_code").filter(":not(.mask-inited)").inputmask({
        definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
        },
        mask: "###-###",
        placeholder: "_"
    }).addClass("mask-inited");

    $(".birthday-mask").filter(":not(.mask-inited)").inputmask({
        definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
        },
        mask: "##.##.####",
        placeholder: "_"
    }).addClass("mask-inited");

    $(".snils").filter(":not(.mask-inited)").inputmask({
        definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
        },
        mask: "###-###-### ##",
        placeholder: "_"
    }).addClass("mask-inited");

    $(document).on("change keyup input click", ".only-num", function(){
        if (this.value.match(/[^0-9]/g)) {
            this.value = this.value.replace(/[^0-9]/g, '');
        }
    });


}


/*

 Form Validation

 */

function validate_init()
{
    if (!$.validator) return;

    if (!$("body").hasClass("validate-inited")) {

        $(document).on("reset", ".form-validate form", function () {
            $(this).find(".textfield, :input").removeClass("error");
            setTimeout(function () {
                $(":input").trigger("change");
                $(".checkbox-plain-js input[type='checkbox'], .checkbox-plain-js input[type='radio']").trigger("change-pseudo");
            }, 50);
        });

        $.validator.setDefaults({
        });

        $.extend($.validator.messages, {
            required: "Обязательное поле.",
            email: "Некорректный E-mail.",
            phonecomplete: "Неполный номер телефона.",
            latlng: "Некорректные координаты.",
            complexity: "Некорректный формат.",
            digits: "Только цифры.",
            passport: "Неполный номер паспорта",
            card: "Неполный номер карты",
        });

        $.validator.addMethod("email", function( value, element ) {
            return this.optional( element ) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( value ); // /^[a-zA-Z\-\._]+@[a-z0-9\-]+(\.[a-z0-9\-]+)*\.[a-z]+$/i
        });

        $.validator.addMethod("phonecomplete", function( value, element ) {
            return this.optional( element ) || (value.replace(/\D/, "").length >= 7 && $(element).inputmask('isComplete'));
        });

        $.validator.addMethod("passport", function( value, element ) {
            return this.optional( element ) || (value.replace(/\D/, "").length >= 10 && $(element).inputmask('isComplete'));
        });

        $.validator.addMethod("card", function( value, element ) {
            return this.optional( element ) || (value.replace(/\D/, "").length >= 12 && $(element).inputmask('isComplete'));
        });

        $.validator.addMethod("password", function( value, element ) {
            return this.optional( element ) || value.length >= 6;
        }, "Должно быть не меньше 6 символов.");

        $.validator.addMethod("passwordconfirm", function( value, element ) {
            var $password = $($(element).data("rule-passwordconfirm-password"));
            return this.optional( element ) || !$password.length || !$password.val() || value === $password.val();
        }, "Пароль не совпадает с подтверждением.");

        $.validator.addMethod("emailconfirm", function( value, element ) {
            var $email = $($(element).data("rule-emailconfirm-password"));
            return this.optional( element ) || !$email.length || !$email.val() || value === $email.val();
        }, "E-mail должны совпадать.");

        $.each($.validator.methods, function (key, value) {
            $.validator.methods[key] = function () {
                if(arguments.length > 0) {
                    arguments[0] = $.trim(arguments[0]);
                }
                return value.apply(this, arguments);
            };
        });

        $(document).on("keyup blur change check-form", ".form-disabled-until-valid :input", function () {
            var $form = $(this).closest(".form-disabled-until-valid");
            var $button = $form.find(".disabled-until-valid");
            $button.prop('disabled', !$form.validate().checkForm());
        });

        $(document).on("change change-checkbox-valid", "input[type='checkbox'], input[type='radio']", function () {
            var $form = $(this).closest("form");
            var validator = $form.data("validator");
            if (validator) $(this).valid();
        });

        $("body").addClass("validate-inited");
    }

    var $forms = $(".form-validate form").not(".form-validate-inited");
    $forms.each(function(){
        $(this).validate({
            onkeyup: false,
            normalizer: function( value ) {
                return $.trim( value );
            },
            errorClass: 'form--error',
            validClass: 'valid',
            errorElement: 'div',
            highlight: function(element, errorClass, validClass) {
                $(element).addClass('error').removeClass('valid');
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).addClass('valid').removeClass('error');
            },
            errorPlacement: function(error, element) {
                $(element).closest(".form--item").append(error);
            },
            submitHandler: function(form, e) {
                $(form).trigger("submit.valid");
            }
        });

        $(this).addClass("form-validate-inited")
    });

    $(".form-disabled-until-valid").find(":input").first().trigger("check-form");

}


/*

Custom Checkboxes

 */

function checkbox_plain_init() {
    $(".checkbox-plain-js").find("[type='checkbox'], [type='radio']").not(".checkbox-plain-js-inited").on("change change-pseudo", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        if ($(this).is(":radio"))
        {
            var name = $(this).attr("name");
            var $radios = $(this).closest("form").find("[name='"+name+"']");
            if (!$radios.length) $radios = $("input[name='"+name+"']");
            $radios.closest(".checkbox-plain-js").removeClass("checked");
        }
        if ($(this).prop("checked")) $o.addClass("checked");
        else $o.removeClass("checked");
        if ($(this).prop("disabled")) $o.addClass("disabled");
        else $o.removeClass("disabled");
    }).on("focus", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        if (!$(this).prop("disabled")) $o.addClass("focused");
    }).on("blur", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        $o.removeClass("focused");
    }).each(function(){
        var $o = $(this).closest(".checkbox-plain-js");
        if ($(this).prop("checked")) $o.addClass("checked");
        if ($(this).prop("disabled")) $o.addClass("disabled");
    }).addClass("checkbox-plain-js-inited").closest(".checkbox-plain-js").addClass("checkbox-plain-js-inited").find("input:text").on("focus", function(){
        $(this).closest(".checkbox-plain-js").find(":checkbox,:radio").prop("checked", true).trigger("change");
    });
}



function datepickerinit(){
    jQuery(function($){
        $.datepicker.regional['ru'] = {
            closeText: 'Закрыть',
            prevText: '&#x3c;Пред',
            nextText: 'След&#x3e;',
            currentText: 'Сегодня',
            monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь',
                'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
                'Июл','Авг','Сен','Окт','Ноя','Дек'],
            dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
            dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
            dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
            weekHeader: 'Нед',
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ''};
        $.datepicker.setDefaults($.datepicker.regional['ru']);
    });


    $( ".datepicker" ).datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "1950:2019"
    });
}


/* UI Slider init*/


function ui_slider_init() {


    $( "#u-slider" ).slider({
        range: "min",
        value: 500000,
        min: 10000,
        max: 3000000,
        step: 10000,
        slide: function( event, ui ) {
            $( ".offer-sum--amount" ).html( ui.value.toLocaleString() + "<span> рублей</span>");
            $( "input[name='form_AMOUNT']" ).val( ui.value);
        }
    });
    $( ".offer-sum--amount" ).html( $( "#u-slider" ).slider( "value" ).toLocaleString() + "<span> рублей</span>" );
    $( "input[name='form_AMOUNT']" ).val( $( "#u-slider" ).slider( "value" ));


    $('select').selectBox();


}